/* eslint-disable no-shadow */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { PlatformType } from "./platform-type";
import { PlatformUserAgent } from "./platform-user-agent";
import { type SystemInfoBuild, type SystemInfoWifiNetwork, type SystemInfoEthernetNetwork } from "./platform-device-info";
import { PlatformDeviceInfo } from "./platform-device-info";

enum TizenStatus {
    ON = "ON",
    OFF = "OFF",
    CONNECTED = "CONNECTED",
    DISCONNECTED = "DISCONNECTED",
    DEACTIVATED = "DEACTIVATED",
}

export enum TizenOSVersion {
    Unknown = "unknown",
    V5_5 = "5.5",
    V6_0 = "6.0",
    V6_5 = "6.5",
    V7_0 = "7.0",
    V8_0 = "8.0",
    V9_0 = "9.0"
}

export class PlatformTizen extends PlatformUserAgent {

    constructor() {
        super(PlatformType.Tizen)
    }

    public static matchThisPlatform(): boolean {
        return window.navigator.userAgent.toLowerCase().includes("tizen");
    }

    isSupported(): boolean {
        return true;
    }
    async getDeviceInfo(): Promise<PlatformDeviceInfo> {
        const baseInfo = await super.getInfo();

        const getProperty = <T>(key: string): Promise<T> =>
            new Promise((resolve, reject) =>
                (window as any)?.tizen.systeminfo.getPropertyValue(key, resolve, reject)
            );

        let model = "", manufacturer ="", buildVersion = "", wifiMacAddress = null, signalStrength = 0, cableMacAddress = "", ssid = null;
        let wifiStatus = "", cableStatus = "", cablePlugged = null;

        try {
            const build = await getProperty<SystemInfoBuild>("BUILD");
            model = build.model ?? "";
            manufacturer = build.manufacturer ?? "";
            buildVersion = build.buildVersion ?? "";
        } catch (error) {
            console.error(`API error get build: ${error}`);
        }
        try {
            const wifi = await getProperty<SystemInfoWifiNetwork>("WIFI_NETWORK");
            wifiMacAddress = wifi.macAddress;
            ssid = wifi.ssid;
            wifiStatus = wifi.status;
            signalStrength = wifi.signalStrength ?? 0;
        } catch (error) {
            console.error(`API error get wifi network: ${error}`);
        }
        try {
            const ethernet = await getProperty<SystemInfoEthernetNetwork>("ETHERNET_NETWORK");
            cableMacAddress = ethernet.macAddress ?? "";
            cableStatus = ethernet.status;
            cablePlugged = ethernet.cable;
        } catch (error) {
            console.error(`API error get ethernet network: ${error}`);
        }

        return new PlatformDeviceInfo(
            cableStatus !== TizenStatus.CONNECTED ? wifiMacAddress : cableMacAddress || baseInfo.macAddress,
            {
                model: model,
                manufacturer: manufacturer,
                buildVersion: buildVersion,
            },
            {
                macAddress: wifiMacAddress,
                signalStrength: signalStrength,
                ssid: ssid,
                status: wifiStatus,
            },
            {
                status: cableStatus,
                macAddress: cableMacAddress,
                cable: cablePlugged,
            }
        );
    }

    public getOSVersion(): string | null {
        // TODO: Implement get OS version for Tizen from the device API
        const ua = window.navigator.userAgent.toLowerCase();
        // eslint-disable-next-line no-useless-escape
        const match = ua.match(/tizen[ /]?([\d\.]+)/i);
        return match ? match[1] : null;
    }
};